import React from 'react';
import { compose } from 'redux';
import AdminTemplate from 'components/templates/Admin';
import HeaderContainer from 'containers/HeaderContainer';
import CapabilityGroupViewContainer from 'containers/CapabilityGroupViewContainer';
import ProtectedRoute from 'hoc/ProtectedRoute';
import SideBarContainer from 'containers/SideBarContainer';
import TitleContainer from 'containers/TitleContainer';
import { AdminBreadcrumb, AdminBreadcrumbItem } from 'components/atoms/AdminBreadcrumb';
import PageTitle from 'hoc/PageTitle';
import { SideBarObjects } from 'components/pages/config/AdminSideBarObjects';
import { ADMINAREA_ACCESS, CAPABILITY_GROUP_READ } from 'constants/capabilities';

const ViewCapabilityGroupPage = props => (
    <AdminTemplate
        header={<HeaderContainer admin />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<TitleContainer
            title={(
                <AdminBreadcrumb>
                    <AdminBreadcrumbItem to="/admin/capability-groups">&lt; Capability Groups</AdminBreadcrumbItem>
                </AdminBreadcrumb>)}
            admin hideDatePicker />}>

        <CapabilityGroupViewContainer {...props} />
    </AdminTemplate>
);

export default compose(
    PageTitle({ pageTitle: 'View Capability Group', showGGBranding: true }),
    ProtectedRoute({ requiredCapabilities: [ADMINAREA_ACCESS, CAPABILITY_GROUP_READ] }),
)(ViewCapabilityGroupPage);



// WEBPACK FOOTER //
// ./src/components/pages/admin/capabilityGroups/ViewCapabilityGroups.js